import React from 'react';
import styled from 'styled-components';

import colors from 'styles/theme/colors';
import textStyles from 'styles/theme/textStyles';
import Logo from 'svg/Logo';

export default function SimpleLandingPage({ children }) {
  return (
    <Content>
      <Widget>
        <WidgetContent>
          <LogoPill>
            <Logo width={100} height={31} />
          </LogoPill>
          {children}
        </WidgetContent>
      </Widget>
      <SupportBox>
        <p>
          Have a question or need help? Contact our support team at{' '}
          <a href='mailto:support@olio.health'>support@olio.health</a>
        </p>
      </SupportBox>
    </Content>
  );
}

const Content = styled.main`
  align-items: center;
  background: linear-gradient(135deg, ${colors.brandNavy100} 0%, ${colors.blue100} 100%);
  display: flex;
  flex-direction: column;
  font-family: ${textStyles.base.fontFamily};
  gap: 32px;
  min-height: 100vh;
  justify-content: center;
  padding: 24px 16px;
`;

const Widget = styled.div`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  background-color: ${colors.white};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  min-width: 320px;
  width: 40%;
`;

const WidgetContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  padding: 40px;
`;

const LogoPill = styled.div`
  align-items: center;
  background-color: ${colors.brandNavy100};
  border-radius: 9999px;
  display: flex;
  height: 60px;
  justify-content: center;
  width: 140px;
`;

const SupportBox = styled.div`
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid ${colors.white};
  border-radius: 8px;
  color: ${colors.white};
  font-family: ${textStyles.base.fontFamily};
  font-size: 14px;
  line-height: 22px;
  max-width: 400px;
  min-width: 320px;
  padding: 16px 24px;
  text-align: center;
  width: 40%;

  & p {
    margin: 0;
  }

  & a {
    color: ${colors.white};
    font-weight: 500;
  }
`;
